export const GENERATE_PASSWORD_HINT =
  "! Пароль для входа будет сгенерирован автоматически и выслан на указанную почту вместе с договором.";
export const NUMBER_AS_LOGIN_AND_PASSWORD_AS_NUMBER =
  "! Email будет использоваться как логин.";
export const PROHIBITION_GAS_STATIONS = "";
export const NUMBER_AS_LOGING =
  "! Логин водителя — это его email!";
